export enum ToiletType {
  UNKNOWN_TOILET_TYPE = 'UNKNOWN_TOILET_TYPE',
  FOR_MAN = 'FOR_MAN',
  FOR_WOMAN = 'FOR_WOMAN',
  UNISEX = 'UNISEX',
  MULTI_PURPOSE = 'MULTI_PURPOSE',
  NURSING_ROOM = 'NURSING_ROOM',
  POWDER_CORNER = 'POWDER_CORNER',
}
